import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import NewEnrollmentForm from "../components/EnrollmentForm/NewEnrollmentForm";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import Error403Page from "./Error403Page";
import ErrorPage from "./ErrorPage";
import DraggableProfilePanel from "../components/common/DraggableProfilePanel";
function Enrollment() {
  const { user, isAuthenticated } = useAuth0();
  const storeuser = useSelector((state) => state.storeuser);
  
  return isAuthenticated ? (
    storeuser && storeuser.usertype === "external" ? (
      <>
      <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true} user={user} />
                </div>
            <div className="content-class">
            <DraggableProfilePanel/>
            <NewEnrollmentForm></NewEnrollmentForm>
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
      </>
    ) : (
      <Error403Page />
    )
  ) : (
    <ErrorPage />
  );
}

export default Enrollment;
